var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from "react";
import { Icon } from "../../tremor/Icon";
import { Input } from "../../tremor/Input";
import { Button } from "../../tremor/Button";
import { useEffect, useState } from "react";
import { create } from "zustand";
import { useDashboard } from "../../layouts/Dashboard/useDashboard";
import { useBackend } from "../../layouts/Wrapper";
import { Text, Label } from "../../tremor/Text";
import { Editor, EditorProvider, BtnBold, BtnBulletList, BtnClearFormatting, BtnItalic, BtnLink, BtnNumberedList, BtnRedo, BtnStrikeThrough, BtnUnderline, BtnUndo, HtmlButton, Separator, Toolbar, } from "react-simple-wysiwyg";
import { twMerge } from "tailwind-merge";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/20/solid";
import ChartBase from "../Chart/ChartBase";
import { Tabs, TabsList, TabsTrigger } from "../../tremor/Tabs";
import { Card } from "../../tremor/Card";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger, } from "../../tremor/Accordion";
import { Textarea } from "../../tremor/Textarea";
import { SparklesIcon } from "@heroicons/react/24/solid";
import { toast } from "sonner";
import { useMaxHeight } from "../../lib/useMaxHeight";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
export const useTextWidgetModal = create((set) => ({
    open: false,
    setOpen: (op, wid) => set({ open: op, widget: wid }),
}));
export const TextWidgetModal = ({}) => {
    var _a;
    const { dashboard, refreshWidgets, tab } = useDashboard();
    const { backend, adminMode } = useBackend();
    const { open, setOpen, widget } = useTextWidgetModal();
    const { lg, sm } = useMaxHeight();
    const [title, setTitle] = useState("");
    const [subtitle, setSubtitle] = useState("");
    const [prompt, setPrompt] = useState("");
    const [summaryLoading, setSummaryLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [titleAlignment, setTitleAlignment] = useState("start");
    const [descriptionAlignment, setDescriptionAlignment] = useState("start");
    useEffect(() => {
        if (widget) {
            setTitle(widget.title);
            setSubtitle(widget.subtitle);
            setTitleAlignment(widget.titleAlignment);
            setDescriptionAlignment(widget.descriptionAlignment);
            setPrompt(widget.prompt);
        }
        else {
            setTitle("");
            setSubtitle("");
            setPrompt("");
            setTitleAlignment("start");
            setDescriptionAlignment("start");
        }
    }, [widget]);
    const createWidget = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!dashboard || !backend)
            return;
        setLoading(true);
        let cache = {
            type: "text",
            data: { datasets: [{ data: [], label: "" }] },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    title: { display: true, text: title, align: titleAlignment },
                    text: {
                        prompt: prompt,
                    },
                    subtitle: {
                        display: false,
                        text: subtitle,
                        align: descriptionAlignment,
                    },
                },
            },
        };
        if (widget) {
            yield backend.widgets.update(widget.id, {
                title: title,
                code: "",
                config: cache,
            });
        }
        else {
            yield backend.widgets.create({
                dashboard: dashboard.id,
                layouts: {
                    lg: {
                        x: 0,
                        y: lg,
                        w: 12,
                        h: 10,
                    },
                    sm: {
                        x: 0,
                        y: sm,
                        w: 3,
                        h: 10,
                    },
                },
                use_in_library: false,
                use_in_chat: false,
                title: title,
                team: dashboard.team,
                code: "",
                messages: [],
                settings: {},
                error: null,
                tab: tab || 0,
                config: cache,
                engine: "manual-v1",
                type: "text"
            });
        }
        setOpen(false);
        setLoading(false);
        setTitle("");
        setSubtitle("");
        refreshWidgets(backend);
    });
    const summarize = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!backend || !dashboard)
            return;
        setSummaryLoading(true);
        try {
            let data = yield backend.dashboard(dashboard.id).summarize(prompt);
            setTitle(data.title);
            setSubtitle(data.description);
            setSummaryLoading(false);
        }
        catch (e) {
            toast.error("Failed to summarize: " + e.message);
            setSummaryLoading(false);
        }
    });
    if (!((_a = dashboard === null || dashboard === void 0 ? void 0 : dashboard.settings) === null || _a === void 0 ? void 0 : _a.can_create_widgets) && !adminMode)
        return React.createElement(React.Fragment, null);
    return (React.createElement(React.Fragment, null,
        React.createElement("dialog", { open: open },
            React.createElement("div", { className: twMerge("onvo-@container/widgetmodal onvo-h-full onvo-animate-dialogOpen onvo-w-full onvo-z-50 onvo-fixed onvo-top-0 onvo-left-0 onvo-foreground-color") },
                React.createElement("div", { className: "onvo-foreground-color onvo-w-full onvo-left-0 onvo-top-0 onvo-z-10 onvo-flex onvo-flex-row onvo-justify-start onvo-items-center onvo-gap-4 onvo-border-solid onvo-border-b onvo-border-black/10 onvo-p-2 dark:onvo-border-white/10" },
                    React.createElement(Icon, { icon: ChevronLeftIcon, variant: "shadow", className: "onvo-ml-2 onvo-background-color onvo-border-solid onvo-border onvo-border-black/10 dark:onvo-border-white/10", onClick: () => setOpen(false) }),
                    React.createElement("div", { className: "onvo-flex onvo-flex-row onvo-w-full onvo-gap-1 onvo-flex-grow onvo-justify-start onvo-items-center" },
                        React.createElement(Text, { className: "onvo-hidden @xl/widgetmodal:onvo-block" }, dashboard === null || dashboard === void 0 ? void 0 : dashboard.title),
                        React.createElement(ChevronRightIcon, { className: "onvo-hidden @xl/widgetmodal:onvo-block onvo-h-4 onvo-w-4 dark:onvo-fill-slate-500" }),
                        React.createElement(Label, null, widget ? `Edit ${title}` : "Create text widget")),
                    React.createElement("div", { className: "onvo-flex onvo-flex-row onvo-gap-2 onvo-flex-shrink-0" },
                        React.createElement(Button, { onClick: createWidget, className: "onvo-flex-shrink-0", isLoading: loading }, widget ? "Save" : "Create"))),
                React.createElement("div", { className: "onvo-relative onvo-flex onvo-flex-grow onvo-h-[calc(100%-52px)] onvo-w-full" },
                    React.createElement(PanelGroup, { autoSaveId: "edit-widget", direction: "horizontal" },
                        React.createElement(Panel, { defaultSize: 50, minSize: 25 },
                            React.createElement("div", { className: "onvo-relative onvo-overflow-y-auto onvo-scrollbar-thin onvo-flex-grow onvo-h-full onvo-w-full onvo-p-4 onvo-flex onvo-flex-col onvo-justify-center" },
                                React.createElement(Text, null, "Title"),
                                React.createElement(Input, { placeholder: "Type in a title", value: title, inputClassName: "onvo-background-color onvo-border-black/10 dark:onvo-border-white/10", onChange: (e) => setTitle(e.target.value) }),
                                React.createElement("div", { className: "onvo-mt-2 onvo-flex onvo-items-center onvo-justify-between" },
                                    React.createElement(Text, null, "Title alignment"),
                                    React.createElement(Tabs, { value: titleAlignment, onValueChange: (val) => {
                                            setTitleAlignment(val);
                                        } },
                                        React.createElement(TabsList, { variant: "solid" },
                                            React.createElement(TabsTrigger, { value: "start" }, "Left"),
                                            React.createElement(TabsTrigger, { value: "center" }, "Center"),
                                            React.createElement(TabsTrigger, { value: "end" }, "End")))),
                                React.createElement(Text, { className: "onvo-mt-2" }, "Description"),
                                React.createElement("div", { className: "onvo-min-h-48 onvo-max-w-full onvo-prose onvo-prose-slate onvo-prose-sm dark:onvo-prose-invert" },
                                    React.createElement(EditorProvider, null,
                                        React.createElement(Editor, { containerProps: { style: { minHeight: 192 } }, value: subtitle, onChange: (e) => setSubtitle(e.target.value) },
                                            React.createElement(Toolbar, null,
                                                React.createElement(BtnUndo, null),
                                                React.createElement(BtnRedo, null),
                                                React.createElement(Separator, null),
                                                React.createElement(BtnBold, null),
                                                React.createElement(BtnItalic, null),
                                                React.createElement(BtnUnderline, null),
                                                React.createElement(BtnStrikeThrough, null),
                                                React.createElement(Separator, null),
                                                React.createElement(BtnNumberedList, null),
                                                React.createElement(BtnBulletList, null),
                                                React.createElement(Separator, null),
                                                React.createElement(BtnLink, null),
                                                React.createElement(BtnClearFormatting, null),
                                                React.createElement(HtmlButton, null))))),
                                React.createElement("div", { className: "onvo-mt-2 onvo-flex onvo-items-center onvo-justify-between" },
                                    React.createElement(Text, null, "Description alignment"),
                                    React.createElement(Tabs, { value: descriptionAlignment, onValueChange: (val) => {
                                            setDescriptionAlignment(val);
                                        } },
                                        React.createElement(TabsList, { variant: "solid" },
                                            React.createElement(TabsTrigger, { value: "start" }, "Left"),
                                            React.createElement(TabsTrigger, { value: "center" }, "Center"),
                                            React.createElement(TabsTrigger, { value: "end" }, "End")))),
                                React.createElement("div", { className: "onvo-mt-2 onvo-flex onvo-items-center onvo-justify-between" },
                                    React.createElement(Card, { className: "!onvo-p-0 onvo-background-color" },
                                        React.createElement(Accordion, { type: "single", collapsible: true },
                                            React.createElement(AccordionItem, { value: "item-1", className: "onvo-border-b-0" },
                                                React.createElement(AccordionTrigger, { className: "onvo-background-color onvo-px-3 onvo-rounded-2xl" },
                                                    React.createElement("div", { className: "onvo-flex onvo-gap-2 onvo-items-center onvo-justify-start" },
                                                        React.createElement(SparklesIcon, { className: "onvo-h-4 onvo-w-4" }),
                                                        "Generate text with AI")),
                                                React.createElement(AccordionContent, { className: "onvo-px-3 onvo-relative" },
                                                    React.createElement(Textarea, { placeholder: "Enter prompt for AI", className: "onvo-mt-2 onvo-foreground-color", value: prompt, onChange: (e) => setPrompt(e.target.value) }),
                                                    React.createElement("div", { className: "onvo-w-full onvo-flex onvo-justify-end onvo-mt-2" },
                                                        React.createElement(Button, { isLoading: summaryLoading, onClick: summarize }, "Generate"))))))))),
                        React.createElement(PanelResizeHandle, { className: "onvo-w-[1px] onvo-border-0 onvo-bg-black/10 dark:onvo-bg-white/10 hover:onvo-bg-black/50 dark:hover:onvo-bg-white/50 active:onvo-bg-black/50 dark:active:onvo-bg-white/50" }),
                        React.createElement(Panel, { minSize: 25 },
                            React.createElement("div", { className: "onvo-h-full onvo-background-color onvo-flex onvo-flex-shrink-0 @xl/widgetmodal:onvo-flex-shrink onvo-flex-col onvo-justify-center onvo-w-full onvo-flex-grow onvo-relative onvo-p-4 onvo-overflow-y-auto onvo-bg-[radial-gradient(#e2e8f0_1px,transparent_1px)] dark:onvo-bg-[radial-gradient(#0f172a_1px,transparent_1px)] [background-size:16px_16px]" },
                                React.createElement("div", { className: "onvo-relative onvo-flex onvo-w-full onvo-flex-col" },
                                    React.createElement(ChartBase, { json: {
                                            type: "text",
                                            data: { datasets: [{ data: [], label: "" }] },
                                            options: {
                                                responsive: true,
                                                maintainAspectRatio: false,
                                                plugins: {
                                                    title: {
                                                        display: true,
                                                        text: title,
                                                        align: titleAlignment,
                                                    },
                                                    subtitle: {
                                                        display: false,
                                                        text: subtitle,
                                                        align: descriptionAlignment,
                                                    },
                                                },
                                            },
                                        }, title: title }))))))))));
};
//# sourceMappingURL=TextWidgetModal.js.map